export const MAX_TAG_NAME_VIEW = 30
export const MAX_TAG_VALUE_VIEW = 30

export const MAX_TAG_NAME_LENGTH = 128
export const MAX_TAG_VALUE_LENGTH = 256
